import React, { Component } from "react";
import * as Constants from "../../../../common/Global/constants";
import { getLocalStorageVariables, handleTokenExpiry, ifEmptyReturn, isEmptyArray, isEmptyVariable } from "../../../../common/Global/commonFunctions";

import { Modal } from "react-bootstrap";
import moment from "moment";
let userDetails = getLocalStorageVariables();

class ReviewHistoryDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			componentDidMountFlag: false,
			showLoader: false,
			datalist: [],
			// totalCount:0,
			currentPageNo: 1,
		};
		userDetails = getLocalStorageVariables();
	}

	componentDidMount() {}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showReviewCommentsDialog) {
			this.setState({
					componentDidMountFlag: false,
					showLoader: false,
					datalist: [],
					// totalCount:0,
					currentPageNo: 1,
					showCreateDialog: false,
				},() => {
					this.getInitData();
				}
			);
		}
	}
	// handleCreateDialogShow = () => {
	// 	this.setState({
	// 		showCreateDialog: true,

	// 		selectedId: "",
		
	// 	});
	// };

	// handleAddDialogClose = (reloadFlag) => {
	// 	this.setState(
	// 		{
	// 			showCreateDialog: false,
	// 		},
	// 		() => {
	// 			if (reloadFlag) this.getInitData();
	// 		}
	// 	);
	// };

	getInitData = () => {
		this.setState({
			showLoader: true,
		});

		let url = "";
		let reviewHistoryUrl = "";
		let postParam = {
			email: userDetails.email,
			accessToken: userDetails.accessToken,
			assignmentSampleCheckedId: this.props.masterDataId,
			assignmentId:this.props.assignmentId,
			pageNo:this.state.currentPageNo
		}
		if(this.props.isDraftOnward === true){
			url = Constants.GetDraftSampleCheckedRemarks;
			reviewHistoryUrl = Constants.GetDraftSampleCheckedAuditTrail;
			if(!this.props.isCompletedOnward){
				postParam.forDraft = true;
			}
		}else{
			if(this.props.isInitDraftOnward){
				postParam.forDraft = true;
			}
			url=Constants.GetSampleCheckedRemarks;
			reviewHistoryUrl = Constants.GetSampleCheckedAuditTrail;
		}
		if(this.props.isCompletedOnward){
			postParam.forCompleted = true;
		}
		Promise.all([
			fetch(url, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams(postParam),
			}),
			fetch(reviewHistoryUrl, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams(postParam),
			})
		])
		.then(([sampleCheckedRemark, sampleCheckedReviewHistory]) => {
			return Promise.all([sampleCheckedRemark.json(),sampleCheckedReviewHistory.json()]);
		})
		.then(([sampleCheckedRemark, sampleCheckedReviewHistory]) => {
			let sampleCheckedRemarkList = [];
			let reviewHistoryList = [];
			if(handleTokenExpiry(sampleCheckedRemark.responseCode)) return;
			else if (sampleCheckedRemark.responseCode === Constants.CODE_SUCCESS) {
				sampleCheckedRemarkList = sampleCheckedRemark.data.remarks;
			} else {
			}

			if(handleTokenExpiry(sampleCheckedReviewHistory.responseCode)) return;
			else if (sampleCheckedReviewHistory.responseCode === Constants.CODE_SUCCESS) {
				reviewHistoryList = sampleCheckedReviewHistory.data.auditTrail
			} else {
			}

			const mergedList = [
				...((sampleCheckedRemarkList || []).map(item => ({
					...item,
					type: 'remark'
				}))),
				...((reviewHistoryList || []).map(item => ({
					...item,
					type: 'history'
				})))
			].sort((a, b) => new Date(b.createDate) - new Date(a.createDate));

			this.setState({
				datalist: mergedList,
				showLoader: false,
				componentDidMountFlag: true,
			});
		});	
	};

	render() {
		return (
			<Modal className="review-history-dialog custom-dialog" show={this.props.showReviewCommentsDialog} onHide={this.props.handleReviewCommentsDialogClose}>
				<Modal.Header>
					<h5>Review Comments</h5>
					<button onClick={this.props.handleReviewCommentsDialogClose} type="button" data-dismiss="modal">
						<span class="material-icons">close</span>
					</button>
				</Modal.Header>
				<hr />
				<div className="modal-body">
					{this.state.showLoader && (
						<div class="loader"></div>
					)}
					<div className="review-history-wrapper">
						<div className="search-addnew-bg">
							<div className="search-addnew">
								<div></div>
								{/* <AddNewButtonLayout themeSettings={this.props.themeSettings}>
									<a onClick={this.handleCreateDialogShow} href="javascript:void(0);">
										<span className="material-icons">add_circle</span>
										<p>Add New</p>
									</a>
								</AddNewButtonLayout> */}
							</div>
						</div>
						{this.state.componentDidMountFlag && (
							<div className="review-history-list">
								{!isEmptyArray(this.state.datalist) &&
									this.state.datalist.map((item) => {
										if (item.type === 'remark') {
											return (
												<div className="history-item-layout">
													<p className="font-bold">{item.remark}</p>
													<span>
														{" "}
														{ifEmptyReturn(item.salutation) + " " + item.firstName + " " + ifEmptyReturn(item.middleName) + " " + item.lastName} (
														{item.createBy})
													</span>
													<span className="review-history-date-span">
														{moment(item.createDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MMM-YYYY hh:mm a")}
													</span>
												</div>
											);
										} else if (item.type === 'history') {
											let column = "";
											if(item.column === "notReceived"){
												column = "Not Received";
											}else if(item.column === "verified"){
												column = "Verified";
											}else if(item.column === "received"){
												column = "Received";
											}else if(item.column === "partReceived"){
												column = "Partly Received";
											}
											return (
												<div className="history-item-layout" key={`history-${item.assignmentSampleCheckedId}-${item.column}-${item.createDate}`}>
													<p className="font-bold">{column}</p>
													<p className="review-history-remarks">
														<strong> </strong>
														{(isEmptyVariable(item.oldValue) ? "Checked Partly Received by " + 
															ifEmptyReturn(item.salutation) + " " + item.firstName + " " + ifEmptyReturn(item.middleName) + " " + item.lastName : 
															"Checked Received by " +
															ifEmptyReturn(item.salutation) + " " + item.firstName + " " + ifEmptyReturn(item.middleName) + " " + item.lastName)}
													</p>
													<span className="review-history-date-span">
														{moment(item.createDate, "YYYY-MM-DDTHH:mm:ss.SSSZ").format("DD-MMM-YYYY hh:mm a")}
													</span>
												</div>
											);
										}
									})}
							</div>
						)}
						{this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) && (
							<div className="dialog-no-records">
								<p>{Constants.NO_RECORDS_WARNING}</p>
							</div>
						)}
					</div>
				</div>
				
			</Modal>
		);
	}
}

export default ReviewHistoryDialog;
